export default __webpack_public_path__ + "54af912b06c798d8af06fe019359c044.png";